import { styleOverrides } from "./styleOverrides";

const MuiDialogContent = {
  styleOverrides,
};

export { MuiDialogContent };
